import React from 'react';
import Services from '../components/Services';
import WorkProcess from '../components/WorkProcess';
import ServiceStats from '../components/ServiceStats';
import ServiceFAQ from '../components/ServiceFAQ';
import ServiceTechnologies from '../components/ServiceTechnologies';
import EngagementModels from '../components/EngagementModels';

const ServicesPage = () => {
  return (
    <main className="pt-20">
      <Services />
      <ServiceTechnologies />
      <EngagementModels />
      <ServiceStats />
      <WorkProcess />
      <ServiceFAQ />
    </main>
  );
};

export default ServicesPage;
